// extracted by mini-css-extract-plugin
module.exports = {"overlayClass":"ReplyBar_overlayClass__VCKia"};